/** @format */


export default {
  namespaced:true,
  state: {
    isHeaderFixed: false,
    isShowcolleageHead:false,
    type:'',
    selectIndex:'',
  },
  mutations: {
    setHeaderFixed(state, val) {
      state.isHeaderFixed = val;
    },
    setShowcolleageHead(state,val){
      state.isShowcolleageHead = true
    },
    setType(state, val){
      state.type = val
      console.log('state.type',state.type)
    },
    setIndex(state,val){
      state.selectIndex = val
      console.log('state.selectIndex',state.selectIndex)
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/module/header.js